export const SAMPLE_FILE_NAME = "homebase-team-export.csv";

export const SAMPLE_CSV = `First Name,Last Name,Mobile Phone,Email,Role,Wage Rate,Employee ID,Hire Date,PIN
Jesse,Navarro,(312) 555-7731,jesse.n@example.com,Bartender,18.50,HB-2231,05/12/2024,1234
Corinne,Pak,(312) 555-2208,corinne.pak@example.com,Usher,16,HB-2232,06/03/2024,2345
Malcolm,Reed,(773) 555-0142,mreed@example.com,Security,22,HB-2233,01/15/2023,3456
Yara,Lindqvist,(312) 555-9917,yara.l@example.com,Box office,19,HB-2234,09/22/2024,4567
Pete,Okoro,(312) 555-4410,pete.okoro@example.com,Barback,16,HB-2235,03/08/2025,5678
Delia,Fu,(773) 555-3381,delia.fu@example.com,Bartender,18,HB-2236,11/01/2023,6789
Rex,Albany,(312) 555-6604,rex.albany@example.com,Stagehand,28,HB-2237,07/19/2022,7890
Simone,Achebe,(312) 555-1189,simone.a@example.com,Usher,16,HB-2238,02/27/2025,8901
Hugo,Ferreira,(773) 555-7250,hugo.f@example.com,Security,22,HB-2239,04/14/2024,9012
Wren,Castillo,(312) 555-8023,wren.c@example.com,Bartender,18,HB-2240,08/30/2024,1357
Kim,,,,Security,22,HB-2241,10/05/2025,2468
Ari,Thompson,(312) 555-8890,ari.t@example.com,Lighting tech,30,HB-2242,12/12/2024,3579
`;
